import { lazy } from 'react'

export const ClientsMainLazy = lazy(() => import('./ClientsMain'))
